"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LikeABossEffectHandler = exports.LikeABossEffectArgs = void 0;
const Duration_1 = require("../../Duration");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
const CharmImmunity_1 = require("./CharmImmunity");
const StunImmunity_1 = require("./StunImmunity");
class LikeABossEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.LikeABoss;
        this.__typeName = "LikeABoss";
        this.name = "Like a Boss";
        this.harmful = false;
    }
}
exports.LikeABossEffectArgs = LikeABossEffectArgs;
let LikeABossEffectHandler = class LikeABossEffectHandler {
    apply(sequence, container, state) {
        sequence = sequence.pushSequence("parallel");
        state.meta.effectIds = Array.of(new StunImmunity_1.StunImmunityEffectArgs, new CharmImmunity_1.CharmImmunityEffectArgs).map(effect => container.applyBuff({
            sequence,
            creatorId: state.creatorId,
            targetId: state.targetId,
            duration: Duration_1.Duration.Permanent,
            supernatural: true,
            effect
        }));
    }
    remove(sequence, container, state) {
        sequence = sequence.pushSequence("parallel");
        state.meta.effectIds.forEach(id => container.cancelEffect(sequence, id));
    }
};
LikeABossEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.LikeABoss)
], LikeABossEffectHandler);
exports.LikeABossEffectHandler = LikeABossEffectHandler;
